const OrangeBigDrop = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="453"
      height="584"
      fill="none"
      viewBox="0 0 453 584"
    >
      <path
        fill="#F8E6DD"
        d="M.57 359.714c.31-19.251 4.867-37.759 11.2-55.837 8.208-23.493 19.23-45.678 31.636-67.184 23.819-41.287 51.723-79.809 80.614-117.615 25.415-33.249 50.855-66.452 76.245-99.723 3.926-5.136 7.538-10.519 11.294-15.789.603-.866 1.278-1.687 1.996-2.628 7.393 8.75 14.479 17.417 21.884 25.838 22.948 26.059 46.056 51.994 69.072 78.003 28.881 32.654 57.192 65.774 82.743 101.126 17.955 24.873 34.464 50.642 47.088 78.682 10.944 24.322 18.235 49.523 17.776 76.522-.498 29.862-6.198 58.617-18.185 86.045-15.048 34.48-37.209 63.508-66.654 86.903-28.874 22.953-61.524 37.921-97.693 44.917-37.638 7.26-74.919 5.285-111.55-6.191C118.085 560.274 84.159 538.285 56.381 507c-23.062-25.984-39.22-55.777-48.33-89.337-5.147-18.942-7.774-38.277-7.455-57.88l-.025-.069z"
      ></path>
      <path
        fill="url(#paint0_linear_3105_19386)"
        fillOpacity="0.2"
        d="M.57 359.714c.31-19.251 4.867-37.759 11.2-55.837 8.208-23.493 19.23-45.678 31.636-67.184 23.819-41.287 51.723-79.809 80.614-117.615 25.415-33.249 50.855-66.452 76.245-99.723 3.926-5.136 7.538-10.519 11.294-15.789.603-.866 1.278-1.687 1.996-2.628 7.393 8.75 14.479 17.417 21.884 25.838 22.948 26.059 46.056 51.994 69.072 78.003 28.881 32.654 57.192 65.774 82.743 101.126 17.955 24.873 34.464 50.642 47.088 78.682 10.944 24.322 18.235 49.523 17.776 76.522-.498 29.862-6.198 58.617-18.185 86.045-15.048 34.48-37.209 63.508-66.654 86.903-28.874 22.953-61.524 37.921-97.693 44.917-37.638 7.26-74.919 5.285-111.55-6.191C118.085 560.274 84.159 538.285 56.381 507c-23.062-25.984-39.22-55.777-48.33-89.337-5.147-18.942-7.774-38.277-7.455-57.88l-.025-.069z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_3105_19386"
          x1="195.08"
          x2="186.08"
          y1="74.896"
          y2="566.396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD813E"></stop>
          <stop offset="1" stopColor="#FD813E" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};
export default OrangeBigDrop;
